export type TApplicationsViewMode = 'list' | 'table'

const DEFAULT_VIEW_MODE: TApplicationsViewMode = 'table'
const CURRENT_STORAGE_VERSION = 'table-default-v1'
const getStorageKey = (loginName: string) => `crm:applications-view-mode:${encodeURIComponent(loginName)}`
const getStorageVersionKey = (loginName: string) => `crm:applications-view-mode-version:${encodeURIComponent(loginName)}`

export const loadApplicationViewMode = (loginName: string): TApplicationsViewMode => {
    if (!loginName) return DEFAULT_VIEW_MODE

    try {
        const storageKey = getStorageKey(loginName)
        const storageVersionKey = getStorageVersionKey(loginName)
        if (localStorage.getItem(storageVersionKey) !== CURRENT_STORAGE_VERSION) {
            localStorage.setItem(storageKey, DEFAULT_VIEW_MODE)
            localStorage.setItem(storageVersionKey, CURRENT_STORAGE_VERSION)
            return DEFAULT_VIEW_MODE
        }

        const storedValue = localStorage.getItem(storageKey)
        return storedValue === 'table' || storedValue === 'list' ? storedValue : DEFAULT_VIEW_MODE
    } catch {
        return DEFAULT_VIEW_MODE
    }
}

export const saveApplicationViewMode = (loginName: string, viewMode: TApplicationsViewMode): boolean => {
    if (!loginName) return false

    try {
        localStorage.setItem(getStorageKey(loginName), viewMode)
        return true
    } catch {
        return false
    }
}